module.exports = __webpack_public_path__ + "static/landing-page-grow-money-c0fb6d65592f48d4c25fa4dbb8a2db1f.png";